// 获取token文件的func
import { getToken, setToken } from '@/utils/auth'
/**
 * User STORE
 */

const user = {
  state: {
    token: getToken()
  },
  mutations: {
    // 设置token
    SET_TOKEN (state, token) {
      if (token) {
        state.token = token
        setToken(token)
      }
    }
  },
  actions: {
    /**
     * 用户授权
     * 需要通过mutation在浏览器中创建Token cookie保证一定的授权实效性;
     *
     * @param {any} {commit}
     * @param {any} params
     * @returns
     */
    // 保存token
    getaccessToken ({commit, state}, token) {
      commit('SET_TOKEN', token)
    }
  }

}
export default user
